import { useEffect, useRef, useState } from 'react';
import { t } from '@lingui/core/macro';
import { useToast } from '@pocketlaw/tetris';
import { copyRichText } from './copyRichText';
import { markdownToHtml } from './markdownToHtml';
const TIMEOUT = 2000;
export const useCopyRichText = () => {
    const { addToast } = useToast();
    const [isCopied, setIsCopied] = useState(false);
    const timerRef = useRef(null);
    const runTimeout = () => {
        timerRef.current = setTimeout(() => {
            setIsCopied(false);
        }, TIMEOUT);
    };
    const copyToClipboard = (markdown) => {
        try {
            const html = markdownToHtml(markdown);
            copyRichText(html, markdown);
            setIsCopied(true);
            runTimeout();
            addToast({
                appearance: 'success',
                title: t({
                    message: 'Copied to clipboard!',
                    comment: 'document assistant - assistant reply action - toast when reply has been copied to clipboard',
                }),
            });
        }
        catch (_a) {
            addToast({
                appearance: 'danger',
                title: t({
                    message: 'Failed to copy message',
                    comment: 'document assistant - assistant reply action - toast when reply failed to be copied to clipboard',
                }),
            });
        }
    };
    useEffect(() => () => {
        if (timerRef.current) {
            clearTimeout(timerRef.current);
        }
    }, []);
    return { copyToClipboard, isCopied };
};
